import script from "./ProjectOverviewPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectOverviewPanel.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__